var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoofingRoof(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0.25H15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13V13.25C5.5 13.913 5.23661 14.5489 4.76777 15.0178C4.29893 15.4866 3.66304 15.75 3 15.75V15.75C2.6717 15.75 2.34661 15.6853 2.04329 15.5597C1.73998 15.4341 1.46438 15.2499 1.23223 15.0178C0.763392 14.5489 0.5 13.913 0.5 13.25V11.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13V13.25C10.5 13.913 10.2366 14.5489 9.76777 15.0178C9.29893 15.4866 8.66304 15.75 8 15.75V15.75C7.33696 15.75 6.70107 15.4866 6.23223 15.0178C5.76339 14.5489 5.5 13.913 5.5 13.25V11.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.25V13.25C15.5 13.913 15.2366 14.5489 14.7678 15.0178C14.2989 15.4866 13.663 15.75 13 15.75V15.75C12.337 15.75 11.7011 15.4866 11.2322 15.0178C10.7634 14.5489 10.5 13.913 10.5 13.25V11.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5V4.5C5.5 4.8283 5.43534 5.15339 5.3097 5.45671C5.18406 5.76002 4.99991 6.03562 4.76777 6.26777C4.53562 6.49991 4.26002 6.68406 3.95671 6.8097C3.65339 6.93534 3.3283 7 3 7V7C2.6717 7 2.34661 6.93534 2.04329 6.8097C1.73998 6.68406 1.46438 6.49991 1.23223 6.26777C0.763392 5.79893 0.5 5.16304 0.5 4.5V2.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.25V4.5C10.5 4.8283 10.4353 5.15339 10.3097 5.45671C10.1841 5.76002 9.99991 6.03562 9.76777 6.26777C9.53562 6.49991 9.26002 6.68406 8.95671 6.8097C8.65339 6.93534 8.3283 7 8 7V7C7.33696 7 6.70107 6.73661 6.23223 6.26777C5.76339 5.79893 5.5 5.16304 5.5 4.5V4.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5V4.5C15.5 4.8283 15.4353 5.15339 15.3097 5.45671C15.1841 5.76002 14.9999 6.03562 14.7678 6.26777C14.5356 6.49991 14.26 6.68406 13.9567 6.8097C13.6534 6.93534 13.3283 7 13 7V7C12.337 7 11.7011 6.73661 11.2322 6.26777C10.7634 5.79893 10.5 5.16304 10.5 4.5V2.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7V8.75C3 9.0783 2.93534 9.40339 2.8097 9.70671C2.68406 10.01 2.49991 10.2856 2.26777 10.5178C2.03562 10.7499 1.76002 10.9341 1.45671 11.0597C1.15339 11.1853 0.828305 11.25 0.5 11.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7V8.75C8 9.41304 7.73661 10.0489 7.26777 10.5178C6.79893 10.9866 6.16304 11.25 5.5 11.25C4.83696 11.25 4.20107 10.9866 3.73223 10.5178C3.26339 10.0489 3 9.41304 3 8.75V7",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7V8.75C13 9.41304 12.7366 10.0489 12.2678 10.5178C11.7989 10.9866 11.163 11.25 10.5 11.25C9.83696 11.25 9.20107 10.9866 8.73223 10.5178C8.26339 10.0489 8 9.41304 8 8.75V7",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.25C14.837 11.25 14.2011 10.9866 13.7322 10.5178C13.2634 10.0489 13 9.41304 13 8.75V7",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofingRoof);
export default __webpack_public_path__ + "static/media/roofing-roof.2b8ba39c.svg";
export { ForwardRef as ReactComponent };